/**
 * Admin fleet pricing tiers for a single owner. Mirrors
 * `app/owner/fleet/tiers.tsx` with admin impersonation (?ownerId=) via
 * makeOwnerApi — full create/edit/delete parity, including volume_discount
 * tiers and their measurement period.
 */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { makeOwnerApi } from '../../../../src/api/adminAsOwner';
import FleetTiersScreen, { type TierApiClient } from '../../../../src/screens/FleetTiersScreen';

export default function AdminOwnerFleetTiersScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const client = React.useMemo<TierApiClient>(() => makeOwnerApi(id ?? ''), [id]);
  return <FleetTiersScreen client={client} adminOwnerId={id} />;
}
